export function getFlexhireEnvironment() {
  return process.env.NEXT_PUBLIC_APP_ENV || 'development'
}

export function isProduction() {
  return getFlexhireEnvironment() === 'production'
}

export function isStaging() {
  return getFlexhireEnvironment() === 'staging'
}

export function isDevelopment() {
  return getFlexhireEnvironment() === 'development'
}
